import { BlockError } from '@/blocks.04-project/block-error/block-error';
import forEach from 'lodash-es/forEach';

/***
 * Класс для обработки контента от менеджеров
 */
class Wysiwyg {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент с классом wysiwyg
   */
  constructor({ elem }) {
    this.BlockError = new BlockError({ blockName: 'Wysiwyg', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.Wysiwyg = this;
    this.init();
  }

  init = async () => {
    this.tables = Array.from(this.block.querySelectorAll('table'));
    forEach(this.tables, this.wrapTable);
    this.block.classList.add('wysiwyg_init');
  };

  /**
   * Добавление обёртки для таблиц
   * @param table{HTMLElement} - элемент таблицы
   */
  wrapTable = (table) => {
    const previousElem = table.previousElementSibling;
    const parent = table.parentElement;
    const tableWrapper = document.createElement('div');
    tableWrapper.classList.add('table-responsive', 'custom-scrollbar');
    tableWrapper.insertAdjacentElement('afterbegin', table);

    if (previousElem) {
      previousElem.insertAdjacentElement('afterend', tableWrapper);
    } else {
      parent.insertAdjacentElement('afterbegin', tableWrapper);
    }
    window.Block.CustomScrollbar.init(parent, true);
  };

  destroy = () => {
    if (this.block) {
      this.block.classList.remove('wysiwyg_inited');
      delete this.block.Wysiwyg;
    }
  };

  static init({ container = document } = {}) {
    Array.from(container.querySelectorAll('.wysiwyg:not(.wysiwyg_inited)')).forEach((elem) => new Wysiwyg({ elem }));
  }
}

document.addEventListener('DOMContentLoaded',() => Wysiwyg.init());

// Экспорт;
window.Block.Wysiwyg = Wysiwyg;
